/**
 * @desc Snowmaking hydrants state actions, mutations and default state values
 *
 * @author Mike Hamilton <mike@mikehamilton.ca>
 */

export default {
  state: {
    name: "baseareaoperations",
    layerTitle: "Base Area Operations",
    geojson: [],
    visibility: {
      mapView: false,
      listView: false,
      singleView: false,
      singleId: 0
    },
    loading: false,
    hasListView: false,
    splitIndex: 1
  }
};
